var _ellipse, _path, _path2, _path3, _path4, _line, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Cv50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "50px",
    height: "50px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    opacity: 0.3,
    rx: 20.125,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37d0ee",
    d: "M48,56H17c-2.209,0-4-1.791-4-4V14c0-2.209,1.791-4,4-4h31c2.209,0,4,1.791,4,4v38 C52,54.209,50.209,56,48,56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13,14v18c2.762,0,5-2.238,5-5V15.652c0-0.42,0.264-0.795,0.66-0.934 C20.605,14.033,22,12.18,22,10h-5C14.791,10,13,11.791,13,14z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52,52V31c-2.762,0-5,2.238-5,5v14c0,0.552-0.448,1-1,1h-9c-2.762,0-5,2.238-5,5h16 C50.209,56,52,54.209,52,52z",
    opacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M41,8h-2.025C38.987,7.834,39,7.669,39,7.5C39,3.91,36.09,1,32.5,1S26,3.91,26,7.5 c0,0.169,0.013,0.334,0.025,0.5H24c-1.105,0-2,0.895-2,2v3c0,1.105,0.895,2,2,2h17c1.105,0,2-0.895,2-2v-3C43,8.895,42.105,8,41,8z M32.5,10C31.119,10,30,8.881,30,7.5S31.119,5,32.5,5S35,6.119,35,7.5S33.881,10,32.5,10z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    x2: 16.5,
    y1: 15.5,
    y2: 22.5,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.994,
    cy: 27,
    r: 5,
    fill: "#ffce29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#008aa9",
    d: "M38.005,44h-12.01c-1.105,0-2.001-0.896-2.001-2.001v0c0-4.422,3.585-8.006,8.006-8.006h0 c4.422,0,8.006,3.585,8.006,8.006v0C40.006,43.104,39.11,44,38.005,44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Cv50);
export default __webpack_public_path__ + "static/media/icons8-cv-50.1fa088d304b06f26cc54860e6f360f44.svg";
export { ForwardRef as ReactComponent };